import React from 'react';
import { MonitorIcon, TabletSmartphoneIcon, SmartphoneIcon, PhoneIcon, MailIcon, Share2Icon, SparklesIcon, UserRoundIcon, DatabaseIcon, ShieldCheckIcon, LinkIcon, UsersIcon, SettingsIcon, BarChart3Icon } from 'lucide-react';
import type { EntryKey, CoreKey, DestinationKey } from '../../data/platformOverview';
export const ENTRY_ICONS: Record<EntryKey, typeof MonitorIcon> = {
  web: MonitorIcon,
  portal: TabletSmartphoneIcon,
  mobile: SmartphoneIcon,
  phone: PhoneIcon,
  email: MailIcon,
  social: Share2Icon,
  assistants: SparklesIcon
};
export const CORE_ICONS: Record<CoreKey, typeof MonitorIcon> = {
  identity: UserRoundIcon,
  record: DatabaseIcon,
  rules: ShieldCheckIcon,
  connectors: LinkIcon,
  atna: SparklesIcon
};
export const DEST_ICONS: Record<DestinationKey, typeof MonitorIcon> = {
  ops: UsersIcon,
  admin: SettingsIcon,
  decisions: BarChart3Icon
};

/* Tiny abstract UI fragments — decorative, not real data */
function TasksFragment() {
  return <div className="space-y-1" data-id="element-5585" data-mp="27doma19usd7j">
      {[['bg-[#E8836E]', 72], ['bg-[#F0B24A]', 54], ['bg-[#4FB981]', 84]].map(([dot, w]) => <div key={String(w)} className="flex items-center gap-1.5 rounded bg-white border border-[#EEEDF6] px-1.5 py-1" data-id="element-5586" data-mp="22fn21d0oy7uh">
          <span className={`w-1 h-1 rounded-full ${dot}`} data-id="element-5587" data-mp="1yf38ejfbtmd3" />
          <span className="h-1 rounded-full bg-[#E4E3F2]" style={{
        width: `${w}%`
      }} data-id="element-5588" data-mp="1tddwz2o6z6oh" />
        </div>)}
    </div>;
}
function ControlsFragment() {
  return <div className="space-y-1" data-id="element-5589" data-mp="1jnu8nhhpmkm8">
      {[true, true, false].map((on, i) => <div key={i} className="flex items-center justify-between rounded bg-white border border-[#EEEDF6] px-1.5 py-1" data-id="element-5590" data-mp="1ep9adnm0qb0f" data-mpi={i}>
          <span className="h-1 rounded-full bg-[#E4E3F2]" style={{
        width: `${[56, 42, 64][i]}%`
      }} data-id="element-5591" data-mp="1ao7hrpmlwx7f" />
          <span className={`w-4 h-2.5 rounded-full p-[2px] flex ${on ? 'bg-[#4F46E5] justify-end' : 'bg-[#DCDDE6] justify-start'}`} data-id="element-5592" data-mp="15p4fue1xb73o">
            <span className="w-1.5 h-1.5 rounded-full bg-white" data-id="element-5593" data-mp="10q03jejpct94" />
          </span>
        </div>)}
    </div>;
}
function ChartFragment() {
  return <div className="rounded bg-white border border-[#EEEDF6] px-1.5 pt-1.5 pb-1" data-id="element-5594" data-mp="w1iah1m45fqh">
      <div className="flex items-end gap-[3px] h-[34px]" data-id="element-5595" data-mp="h3py2ibv57gi">
        {[36, 50, 42, 64, 56, 76, 92].map((h, i) => <span key={i} className={`flex-1 rounded-[1px] ${i === 6 ? 'bg-[#4F46E5]' : 'bg-[#D9D7F6]'}`} style={{
        height: `${h}%`
      }} data-id="element-5596" data-mp="m29igeat6b6r" data-mpi={i} />)}
      </div>
    </div>;
}
export const DEST_FRAGMENTS: Record<DestinationKey, () => JSX.Element> = {
  ops: TasksFragment,
  admin: ControlsFragment,
  decisions: ChartFragment
};